import { Button } from "antd";
import styled from "styled-components";

export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  min-width: 115px;
  margin-right: 23px;
`;

export const Row = styled.div<{ marginTop?: string; marginBottom?: string; align?: string; justifyContent?: string }>`
  display: flex;
  align-items: ${({ align }) => align || "center"};
  justify-content: ${({ justifyContent }) => justifyContent || "flex-start"};
  margin-top: ${({ marginTop }) => marginTop};
  margin-bottom: ${({ marginBottom }) => marginBottom};
`;
export const RowContent = styled.div<{ width: number; isRow?: boolean }>`
  width: ${({ width }) => width}px;
  display: ${({ isRow }) => (isRow ? "flex" : "block")};
`;
export const NormalTitle = styled.div<{ marginBottom?: string }>`
  font-size: 14px;
  min-width: 115px;
  margin-right: 23px;
  margin-bottom: ${({ marginBottom }) => marginBottom || ""};
`;
export const GrayText = styled.p`
  color: ${({ theme }) => theme.colorNeutral500};
`;
export const CustomButton = styled(Button)`
  margin-left: 20px;
`;
export const Divide = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.colorNeutral400};
  margin: 28px 0;
`;
export const Wrapper = styled.div`
  padding: 28px 20px 20px 20px;
  margin: 13px 33px 66px 16px;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
`;
export const WrapperPreview = styled.div`
  padding: 28px 20px 20px 20px;
  border: 1px solid #f0f0f0;
  border-radius: 2px;
`;
export const Flex = styled.div`
  display: flex;
  align-items: center;
`;
export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
  padding: 0 25px;
`;

export const HeaderButton = styled(Button)`
  margin-right: 10px;
`;

export const NotesWrapper = styled.div`
  position: relative;
  overflow-x: hidden;
  overflow-y: hidden;
`;
export const Notes = styled.div<{ isExpanded?: boolean }>`
  text-align: left;
  margin: 15px 0;
  white-space: normal;
  overflow-y: ${({ isExpanded }) => (isExpanded ? "hidden" : "scroll")};
  max-height: 112px;
`;
export const ExpandIconImg = styled.img`
  background-color: #fff;
  position: absolute;
  right: 10px;
  bottom: 10px;
  cursor: pointer;
`;
export const ModalContent = styled.section`
  overflow: auto;
`;

export const PreviewFileBtn = styled(Button)`
  margin-left: 20px;
`;
export const PopupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  background-color: white;
  overflow: auto;
`;
export const ErrorTitle = styled.p`
  font-size: 16px;
  font-weight: bold;
`;
export const ErrorText = styled.p`
  margin-bottom: 5px;
`;
export const Footer = styled.div`
  position: fixed;
  right: 25px;
  bottom: 0;
  width: 100%;
  display: flex;
  padding: 13px 12px;
  align-items: center;
  justify-content: flex-end;
  background-color: #fafafa;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.05);
`;

export const CustomFooterButton = styled(Button)<{ marginRight?: string; width?: string }>`
  margin-right: ${({ marginRight }) => marginRight || ""};
  width: ${({ width }) => width || ""};
`;
